import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28105b10")

_pushScopeId("data-v-28105b10")
const _hoisted_1 = { class: "desk-loby-root" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = {
  class: "left",
  id: "left-content"
}
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "list-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_view = _resolveComponent("header-view")
  const _component_banner_view = _resolveComponent("banner-view")
  const _component_d_list_item_multi_view = _resolveComponent("d-list-item-multi-view")
  const _component_d_list_item_view = _resolveComponent("d-list-item-view")
  const _component_setting_view = _resolveComponent("setting-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_header_view, {
      class: "header",
      onOnShowSetting: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettings = true))
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_banner_view, { class: "banner-content" }),
        _createVNode("ul", _hoisted_4, [
          _createVNode("li", {
            class: { active: _ctx.selectedTab === 3 },
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectTab(3)))
          }, _toDisplayString(_ctx.iN('common.allgames')), 3),
          _createVNode("li", {
            class: { active: _ctx.selectedTab === 1 },
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectTab(1)))
          }, _toDisplayString(_ctx.iN('common.baccarat')), 3),
          _createVNode("li", {
            class: { active: _ctx.selectedTab === 2 },
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelectTab(2)))
          }, _toDisplayString(_ctx.iN('common.dragontiger')), 3)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.selectedTab === 3 && _ctx.desks.length > 0)
              ? (_openBlock(), _createBlock(_component_d_list_item_multi_view, {
                  key: 0,
                  class: "item",
                  itemIndex: -2,
                  selectedIndex: _ctx.selectedIndex,
                  desks: _ctx.desks,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectItem(-2)))
                }, null, 8, ["selectedIndex", "desks"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (i) => {
              return (_openBlock(), _createBlock(_component_d_list_item_view, {
                class: "item",
                key: i.deskId,
                deskData: i,
                itemIndex: i.deskId,
                selectedIndex: _ctx.selectedIndex,
                onClick: ($event: any) => (_ctx.selectItem(i.deskId || 0))
              }, null, 8, ["deskData", "itemIndex", "selectedIndex", "onClick"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_setting_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showHistory = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})